import styled from "styled-components"

export const RoleStyled = styled.div`
    padding-top: 20px;
  /* display: flex; */
  /* flex-direction: column; */
  .title-type-1 {
    margin-bottom: 16px;
    padding-top: 0px;
    padding-bottom: 16px;
  }
  .content-table {
    flex: 1 1 auto;
    overflow: hidden;
  }
  .dvc {
    text-align: center;
  }
  .ant-divider {
    margin: 16px 0px;
  }
  .header-recruit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0px;
    margin-bottom: 16px;
  }
  .rq-support {
    height: 37px;
  }
  .title-header-role {
    font-style: normal;
    font-size: 20px;
    line-height: 25px;
    color: #222d4b;
    font-weight: 700;
  }
  ul {
    list-style: none;
    margin-bottom: 0;
    li {
      line-height: 2;
    }
  }
`

export const FooterModal = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
